import { clearForSignIn } from "../../login/login-display.js"
import { fetchGet } from "../../utils/fetch-json.js"

export const requestEncode = (recordId: string) => fetchGet("/v1/media/encode/" + recordId).then(response => {
    // TODO: Implement to remove a button and add a message div instead of changing the display status.
    const encodeTo128KButton = document.getElementById("encodeTo128KButton");
    const encodeTo128KMessage = document.getElementById("encodeTo128KMessage");

    if (encodeTo128KButton) encodeTo128KButton.style.display = "none";
    if (encodeTo128KMessage) {
        encodeTo128KMessage.style.display = "block";
        switch (response.status) {
            case 202: // Accepted
                encodeTo128KMessage.innerHTML =
                    "Now encoding...<br>Please revisit this page after a few minutes.";
                break;
            case 401: // Unauthorized
                clearForSignIn();
                encodeTo128KMessage.innerHTML =
                    "Become a Soundcorset Member to encode!<br>Please sign in.";
                break;
            case 409: // Conflict
                encodeTo128KMessage.innerHTML =
                    "You are not allowed to encode this record.<br>Please check your id.";
                break;
            default: // do nothing
        }
    }
})